module.exports = __webpack_public_path__ + "img/smugglers-cove.9128f1a7.jpg";